import styled from 'react-emotion/macro';
import { Radio, Button } from 'antd';
import {
  width, color, space, border, borderColor as bordercolor, bottom,
} from 'styled-system';

export const ViewChangerPanel = styled.div` &&& {
  position: absolute;
  width: 100%;
  ${color}
  ${space}
  ${border}
  ${bordercolor}
  ${bottom}
  z-index: 99;
  opacity: 0;
  top: 0;
  transition: opacity .3s;

  & > * {
    float: right;
  }

  /* remove the unwanted Antd default border animation */
  .ant-radio-button-wrapper::after {
    border: none;
  }
}`;

export const Wrapper = styled.div` &&& {
  position: relative;
  width: 100%;
  height: 100%;
  ${space}
  ${color}

  .DCRPVisualisationViewChangerPanel {
    width: 50%;
    right: 0;
  }

  &:hover .DCRPVisualisationViewChangerPanel {
    top: 0px;
    opacity: 1;
  }

  thead th {
    background-color: transparent !important;
  }

  .ant-radio-button-wrapper {
    border: none;
    border-left: none;
    border-right: none;
    box-shadow: none;
    background: transparent;

    &::before {
      background: transparent;
      opacity: 0;
    }
  }

  .ant-radio-button-checked {
    ${color}
  }

  .recharts-legend-item-text {
    text-transform: capitalize;
    color: #777;
    letter-spacing: 1px;
    font-weight: lighter;
    font-size: .8em !important;
  }

  h4 {
    ${color}
    font-size: 1.5vh;
    letter-spacing: 2px;
    color: #777;
  }
}`;

export const ViewWrapper = styled.div` &&& {
  height: calc(100% - 45px);
  width: 100%;
  ${space}
  position: absolute;
  left: 0;
  right: 0;
  margin: auto;

  .recharts-wrapper {
    text, span {
      font-size: 1.3vmin;
      letter-spacing: 0px;
      color: #444;
    }

    .recharts-tooltip-wrapper {
      z-index: 9;
    }
  }

  .recharts-legend-wrapper {
    font-size: 1.55vh;
    margin-bottom: 8px !important;

    .recharts-surface {
      width: 1.6vh;
      height: 1.6vh;
    }
  }

  .DCRPChartClickable {
    .recharts-pie-sector,
    .recharts-bar-rectangle {
      cursor: pointer;

      &:hover {
        outline: 2px dashed #000;
        outline-offset: -2px;
      }
    }
  }

  /* The below snippet enables AntD table to resize according to the panel */
  .ant-table-wrapper {
    height: 100%;
    ${width}

    * :not(.ant-table-header)
      :not(.ant-table-body)
      :not(.ant-table-column-sorter)
      :not(i) :not(svg) {
    }

    .ant-table-column-sorter {
      height: 16px;
    }

    /* This is needed so that the scrollable table can display the last row correctly. */
    .ant-table-body {
      height: calc(100% - 80px);
    }

   
    th, td {
      ${space}
      max-width: 0; /* For some reason, I have to add this so that ellipsis works correctly. */

      div, span {
        text-overflow: ellipsis;
        padding-right: 12px;
        white-space: nowrap;
      }
    }
  }
}`;

export const RadioGroup = styled(Radio.Group)` &&& {
  ${space}
  .ant-radio-button-wrapper:hover,
  .ant-radio-button-wrapper-checked {
    ${color}
  }
}`;

export const RadioButton = styled(Radio.Button)` &&& {
  ${space}
}`;

export const HeaderButton = styled(Button)` &&& {
  ${space}
  font-size: 1.2vh;
}`;

export const ContextTotal = styled('b')` &&& {
  position: absolute;
  bottom: -8px;
  left: 0;
  right: 0;
  width: 100%;
  text-align: center;
  text-transform: capitalize;
  font-size: 1.25vh;
  opacity: .55;

  span {
    margin-right: 4px;
  }
}`;
